import Api from "../api/Api";
import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {QUERY_KEYS} from "./queryKeys";
import {ShoppingResult} from "../types/shopping";
import useAuthStore from "../store/authStore";

export default function useGetShoppingCartQuery(checkStatus = false, withPrice = false): UseQueryResult<ShoppingResult, Error> {
  const isAuthenticated = useAuthStore((store) => store.isAuthenticated());

  return useQuery({
    queryKey: [QUERY_KEYS.cart.getShoppingCart, {checkStatus, withPrice}],
    enabled: isAuthenticated, // Only run the query if the user is authenticated
    queryFn: async () => {
      if (!isAuthenticated) return {shoppingItems: {}} as ShoppingResult;

      try {
        return await Api.shopping.GetShoppingCart(checkStatus, withPrice);
      } catch (error) {
        console.error('Error fetching shopping cart:', error);
        throw error;
      }
    },
  });
}
